module.exports = __webpack_public_path__ + "static/img/partInquriy2.1f7f416a.png";